// @ts-nocheck
import React from 'react';
import LegalModal from './LegalModal';
import privacy from '../../assets/privacy';

const PrivacyModal = ({ open, onClose }) => (
  <LegalModal
    open={open}
    onClose={onClose}
    eyebrow="Legal · Privacy"
    titleLead="Privacy"
    titleEm="Notice"
    content={privacy}
    fullLink="https://movology.com/privacy"
  />
);

export default PrivacyModal;
